import Spinner from "./spinner";
import Button from "./button";
import Modal from "./modal";
import Slider from "./slider";
import Popover from "./popover";
import Radio from "./radio";
import Switch from "./switch";
import Input from "./input";
import Select from "./select";
import Checkbox from "./checkbox";
import Skeleton from "./skeleton";
import Progress from "./progress";
import Tabs from "./tabs";

export const components = {
  Spinner,
  Button,
  Modal,
  Slider,
  Popover,
  Radio,
  Switch,
  Input,
  Select,
  Checkbox,
  Skeleton,
  Progress,
  Tabs
};
